export default {
  about: 'À propos',
  requestQuote: 'Demander une Soumission',
  requestAlliance: 'Demander une Alliance',
  editProfile: 'Modifier mon profil',
  completedProjects: 'Projets',
  noAchievements: 'Aucune réalisation',
  alliances: 'Alliances',
  noAlliances: 'Aucune alliance trouvée',
  profileNotFound: 'Profil non trouvé',
  profileNotFoundSubtitle: "Veuillez vérifier l'URL ou contacter l'assistance",
  location: 'Ville',
  languages: 'Langues',
} as const;
